import { SecretsManagerClient, GetSecretValueCommand } from '@aws-sdk/client-secrets-manager';
import { LocationRecord } from '@maxmind/geoip2-node';
import { City } from '@maxmind/geoip2-node/dist/src/models';

interface MaxMindCreds {
  accountId: string;
  licenseKey: string;
}

async function fetchMaxMindCredentials(): Promise<string | undefined> {
  const secretsManagerClient = new SecretsManagerClient({ region: 'us-east-1' });
  const { SecretString } = await secretsManagerClient.send(
    new GetSecretValueCommand({ SecretId: 'production/autolist-web/maxmind' })
  );
  return SecretString;
}

async function maxMindCredentials(): Promise<MaxMindCreds> {
  const maxMindConfig = process.env.MAXMIND_CONFIG || (await fetchMaxMindCredentials());

  if (maxMindConfig === undefined) {
    throw Error('GEOLOCATION - server-side: unable to load maxmind credentials');
  }

  const { accountId, licenseKey } = JSON.parse(maxMindConfig);
  return { accountId, licenseKey };
}

// see below: type must be defined here because its loaded async
interface MaxMindClient {
  city(ipAddress: string): Promise<City>;
}

async function ServerSideMaxmindGeoIPClient(): Promise<Omit<MaxMindClient, 'prototype'>> {
  const { accountId, licenseKey } = await maxMindCredentials();

  // Using an async import here so that it won't get bundled with webpack,
  // since it relies on `fs` package
  const { WebServiceClient } = await import('@maxmind/geoip2-node');
  return new WebServiceClient(accountId, licenseKey);
}

export async function serverSideMaxMindGeolocate(ip: string): Promise<LocationRecord | undefined> {
  const result = await ServerSideMaxmindGeoIPClient().then((client) => client.city(ip));
  if (!result) return undefined;

  return result.location;
}
